import styled from 'styled-components'
import Colors from '../../theme/colors'
import Fonts from '../../theme/fonts'

const InfoCardStyles = styled.div<{ icon: string }>`
  font-family: ${Fonts.fontFamilies.Inter};
  font-size: ${Fonts.fontSizes.p16};
  line-height: 24px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  height: fit-content;

  box-sizing: border-box;
  border-radius: 8px;

  h3 {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: Montserrat;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 32px;
    margin: 0;
    letter-spacing: 0.02em;
  }

  p {
    margin: 0;
  }

  svg {
    margin-right: 10px;
  }

  &.with-title {
    padding: 24px;
  }

  &.with-icon {
    padding: 20px 50px;

    h3:before {
      content: '';
      position: absolute;
      background-image: url('data:image/svg+xml;base64,${props => props.icon}');
      width: 20px;
      height: 20px;
      font-size: 18px;
      left: -30px;
    }

    padding-left: 50px;
  }

  &.Yellow {
    background-color: ${Colors.Primary.yellow100};
    border: 1px solid ${Colors.Primary.yellow500};

    h3 {
      color: ${Colors.Primary.yellow800};

      svg {
        path {
          fill: ${Colors.Primary.yellow800};
        }
      }

      &:before {
        background-color: ${Colors.Primary.yellow100};
        svg {
          path {
            fill: ${Colors.Primary.yellow800};
          }
        }
      }
    }

    p {
      color: ${Colors.Primary.yellow800};
    }
  }

  &.Purple {
    background-color: ${Colors.Secondary.purple100};
    border: 1px solid ${Colors.Secondary.purple600};

    h3 {
      color: ${Colors.Secondary.purple600};

      svg {
        path {
          fill: ${Colors.Secondary.purple600};
        }
      }
    }

    p {
      color: ${Colors.Secondary.purple600};
    }
  }

  &.Pink {
    background-color: ${Colors.Secondary.pink200};
    border: 1px solid ${Colors.Secondary.pink700};

    h3 {
      color: ${Colors.Secondary.pink700};
    }

    p {
      color: ${Colors.Secondary.pink700};
    }
  }
`

export default InfoCardStyles
